export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAAAAACWpiEsAAAAFElEQVR42mP4/7+hwcGBgYEBNwMAFYsN+WyuPSYAAAAASUVORK5CYII="